(function () {
  'use strict';

  var stage = document.querySelector('[data-stage]');
  if (stage) {
    document.querySelectorAll('[data-thumb]').forEach(function (button) {
      button.addEventListener('click', function () {
        stage.src = button.getAttribute('data-thumb');
        document.querySelectorAll('[data-thumb]').forEach(function (b) {
          b.classList.toggle('is-active', b === button);
        });
      });
    });
  }

  var input = document.querySelector('[data-qty-input]');
  if (input) {
    document.querySelectorAll('[data-qty]').forEach(function (button) {
      button.addEventListener('click', function () {
        var next = parseInt(input.value, 10) + parseInt(button.getAttribute('data-qty'), 10);
        input.value = Math.max(1, next);
      });
    });
  }

  // In anteprima il form è inerte: intercettiamo l'invio e mostriamo lo stato,
  // così il cliente capisce che il comportamento reale arriva con Shopify.
  document.querySelectorAll('form[data-preview-inert] .product__add').forEach(function (button) {
    button.closest('form').addEventListener('submit', function (event) {
      event.preventDefault();
      var original = button.textContent;
      button.textContent = 'Disponibile su Shopify';
      button.disabled = true;
      setTimeout(function () {
        button.textContent = original;
        button.disabled = false;
      }, 1800);
    });
  });
})();
